// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"_TRjm4xkl"};